export default __webpack_public_path__ + "static/media/beforeribboncut.e35e84c1.jpeg";